import React from 'react';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';
import { SummaryItemWithEdit } from '../../../../shared/Summary/SummaryItem/SummaryItemWithEdit';
import { SmallBodyText, TextField } from '../../../../../ui-toolkit';

export const FirstMortgagePayoffName: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();
  return (
    <SummaryItemWithEdit
      label={'First Mortgage Payoff Name'}
      tab={'other'}
      field={'firstMortgagePayoffName'}
      onUpdate={(field, value) => onPatchOrderInformation({ firstMortgagePayoffName: value })}
      order={order}
      editControl={TextField}
      editProps={{}}
      data-test-id={'first-mortgage-payoff-name'}
    >
      {order.transaction.firstMortgagePayoffName ?? <SmallBodyText intent={'faded'}>-</SmallBodyText>}
    </SummaryItemWithEdit>
  );
};
